var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"view-feed-item"},[_vm._t("header"),_c('section',{staticClass:"body"},[_vm._t("body")],2),_c('footer',[_vm._t("footer")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }